
var o = document.querySelector("#o");
var current = o.querySelector(':first-child');
var first = current;

// logo
var logo = document.querySelector(".logo");
var hover = false;
logo.addEventListener("mouseenter", function(){
  rand = 100000;
  startAnimating(15);
});
logo.addEventListener("mouseleave", function(){
  hover = false;
  rand= 0;
});

// animation
var lastTime = 0;
var frameCount = 0;
var fps, fpsInterval, startTime, now, then, elapsed;
var rand = 1000 + Math.random() * 1500;
startAnimating(15);

function startAnimating(fps) {
  fpsInterval = 1000 / fps;
  then = window.performance.now();
  startTime = then;  
  animate(0);
}

function animate(currentTime) {
  if (currentTime >= rand )  {    
    //  finish on real O
    setTimeout(function(){
      current.style.display = 'none';
      first.style.display = "block";
      current = first;
    }, 10);
  } else {
    now = window.performance.now();
    elapsed = now - then;
    if (elapsed > fpsInterval) {
      then = now - (elapsed % fpsInterval);
      changeO();
      lastTime = currentTime;
    }    
    requestAnimationFrame(animate);
  } 
}


function changeO(){
  var next = current.nextElementSibling;
  if( next !== null){
    current.style.display = 'none';
    next.style.display = "block";
    current = next;
  } else {
    current.style.display = 'none';
    current = first;
    current.style.display = 'block';
  }
}